import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpButtonComponent from './adpButton.component';

let adpButtonModule = angular.module('adpButton', [
  uiRouter
])

.component('adpButton', adpButtonComponent)

.name;

export default adpButtonModule;



// WEBPACK FOOTER //
// ./src/app/components/adpButton/adpButton.js